import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, forkJoin, of, catchError } from 'rxjs';
import { checkUserExist } from '../actions/sign-up.actions';
import { RegistrationService } from 'src/app/core/services/rerister.service.ts/registrations.service';

@Injectable()
export class checkUserExistEffect {
  constructor(
    private actions$: Actions,
    private registrationService: RegistrationService
  ) {}

  $checkUserExist = createEffect(() => {
    return this.actions$.pipe(
      ofType(checkUserExist['[checkUserExist]CheckUserExist']),
      mergeMap((action) =>
        forkJoin({
          coduluz: this.registrationService.checkRegisterParamsCoduluz(action),
          registerParams: this.registrationService.checkRegisterParams(action),
        }).pipe(
          map(({ coduluz, registerParams }) => {
            return checkUserExist['[checkUserExist]CheckUserExistSuccess']({
              data: { userData: action, coduluz, ...registerParams },
            });
          }),
          catchError((error) => {
            return of(
              checkUserExist['[checkUserExist]CheckUserExistSuccess']({ data: { errors: error?.error?.error } })
            );
          })
        )
      )
    );
  });
}
